import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "className", "componentType"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useMemo } from 'react';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import classnames from 'classnames';
import { createTypographyTheme, ROOT_PREFIX } from './typographyStyles';
var EXCLUDED_VARIANTS = ['subtitleC', 'subtitleD', 'body', 'bodyLink', 'button1', 'button2', 'button2Uppercase', 'button1Uppercase', 'small', 'smallUppercase', 'eyebrow', 'eyebrowUppercase'];
export var EmbersTypography = function EmbersTypography(_ref) {
  var variant = _ref.variant,
    className = _ref.className,
    componentType = _ref.componentType,
    props = _objectWithoutProperties(_ref, _excluded);
  var embersVariantMapping = {
    headerA: 'h1',
    headerB: 'h2',
    headerC: 'h3',
    headerD: 'h4',
    headerE: 'h5',
    subtitleA: 'h6',
    subtitleB: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
  };
  var mapVariant = function mapVariant(variant) {
    switch (variant) {
      case 'headerA':
        return 'h1';
      case 'headerB':
        return 'h2';
      case 'headerC':
        return 'h3';
      case 'headerD':
        return 'h4';
      case 'headerE':
        return 'h5';
      case 'subtitleA':
        return 'subtitle1';
      case 'subtitleB':
        return 'subtitle2';
      case 'subtitleC':
        return 'subtitle3';
      case 'subtitleD':
        return 'subtitle4';
      default:
        return variant;
    }
  };
  var mappedVariant = mapVariant(variant);
  var _variant = !EXCLUDED_VARIANTS.includes(variant) ? mappedVariant : 'inherit';
  var typographyTheme = useMemo(function () {
    return createTypographyTheme(componentType);
  }, [componentType]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: typographyTheme
  }, /*#__PURE__*/React.createElement(Typography, _extends({}, props, {
    variant: _variant,
    className: classnames('EmbersTypography-root', _defineProperty({}, "".concat(ROOT_PREFIX, "-").concat(mappedVariant), mappedVariant), className),
    variantMapping: embersVariantMapping
  })));
};